import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

import EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis'

import EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios from '../estudo-form/EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios'

import EstudoFormGarantiasRecursosFinanceirosDetalhado from '../estudo-form/EstudoFormGarantiasRecursosFinanceirosDetalhado'

//import GestaoPatrimonialFormResumoPatrimonialTotalAtivos from './GestaoPatrimonialFormResumoPatrimonialTotalAtivos'



const GestaoPatrimonialFormResumoPatrimonial = ( { values, estudo, report, report1Pagina, /* indInicial, indFinal,*/ popup } ) => {

    return (
        <>
            <GridContainer>
                {estudo.current.patrimonioImobilizadoDetalhadoBensMoveisImoveis.length > 0 && (
                    <GridItem12
                        className='mb-10'
                    >
                        <EstudoFormGarantiasPatrimonioImobilizadoDetalhadoBensMoveisImoveis
                            values={values}
                            estudo={estudo}
                            report={report}
                            report1Pagina={report1Pagina}
                            //indInicial={indInicial}
                            //indFinal={indFinal}
                            popup={popup}
                        />
                    </GridItem12>
                )}

                {estudo.current.patrimonioImobilizadoDetalhadoNegocios.length > 0 && (
                    <GridItem12
                        className='mb-10'
                    >
                        <EstudoFormGarantiasPatrimonioImobilizadoDetalhadoNegocios
                            values={values}
                            estudo={estudo}
                            report={report}
                            report1Pagina={report1Pagina}
                            //indInicial={indInicial}
                            //indFinal={indFinal}
                            popup={popup}
                        />
                    </GridItem12>
                )}
                
                {estudo.current.recursosFinanceirosDetalhado.length > 0 && (
                    <GridItem12
                        className='mb-10'
                    >
                        <EstudoFormGarantiasRecursosFinanceirosDetalhado
                            values={values}
                            estudo={estudo}
                            report={report}
                            report1Pagina={report1Pagina}
                            //indInicial={indInicial}
                            //indFinal={indFinal}
                            popup={popup}
                            label={
                                LABEL.recursosFinanceiros.toUpperCase() + ': ' + LABEL.instituicao + ' x ' +
                                    LABEL.tipoRecursoFinanceiro
                            }
                            recursosFinanceirosDetalhado={estudo.current.recursosFinanceirosDetalhado}
                            detalhadoTipoRecurso={false}
                        />
                    </GridItem12>
                )}

                {/*values.exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao &&
                estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado.length > 0 && (
                    <GridItem12>
                        <EstudoFormGarantiasRecursosFinanceirosDetalhado
                            values={values}
                            estudo={estudo}
                            report={report}
                            report1Pagina={report1Pagina}
                            //indInicial={indInicial}
                            //indFinal={indFinal}
                            popup={popup}
                            label={
                                LABEL.recursosFinanceiros.toUpperCase() + ': ' + LABEL.tipoRecursoFinanceiro + ' x ' +
                                    LABEL.instituicao
                            }
                            recursosFinanceirosDetalhado={estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado}
                            detalhadoTipoRecurso={true}
                        />
                    </GridItem12>
                )*/}
            </GridContainer>

            {/*
            <GestaoPatrimonialFormResumoPatrimonialTotalAtivos
                values={values}
                estudo={estudo}
                report={report}
                popup={popup}
            />
            */}
        </>
    )
}

export default GestaoPatrimonialFormResumoPatrimonial